export const customStyles = {
    container: (provided: Record<string, any>) => ({
        ...provided,
        maxWidth:250,
        width: '100%',
    }),
    control: (provided: Record<string, any>) => ({
        ...provided,
        minWidth: 200,
        height: 48,
        width: '100%',
        cursor: 'pointer',
        margin: 0,
        fontSize: 16,
        boxShadow: 'none',
    }),
    indicatorSeparator: (provided: Record<string, any>) => ({
        ...provided,
        display: 'none'
    }),
    dropdownIndicator: (provided: Record<string, any>) => ({
        ...provided,
        color: '#0656F8',
        ':hover': {
            color: '#0656F8',
        }
    }),
}